module.exports = __webpack_public_path__ + "img/logout.ce0fc5f9.png";